import { gql } from '@common/hooks';

export const StateCountsFragment = gql`
  fragment StateCountsFragment on StaffingRequest {
    id
    notSubmittedCandidatesCount
    waitingForReviewStaffingRequestApplicationsCount
    offeredOffersStaffingRequestApplicationsCount
    acceptedStaffingRequestApplicationsCount
    withdrawnStaffingRequestApplicationsCount
    rejectedStaffingRequestApplicationsCount
  }
`;

export type StateCountsFragment = {
  id: string;
  notSubmittedCandidatesCount: number;
  waitingForReviewStaffingRequestApplicationsCount: number;
  offeredOffersStaffingRequestApplicationsCount: number;
  acceptedStaffingRequestApplicationsCount: number;
  withdrawnStaffingRequestApplicationsCount: number;
  rejectedStaffingRequestApplicationsCount: number;
};
